import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import styled from 'styled-components'

const ActionBox = styled(Box)`
  display: flex;
  justify-content: flex-end;
`

const StyledButton = styled(Button)`
  visibility: hidden;
`

const HeaderAction = () => (
  <ActionBox>
    <StyledButton variant="outlined" size="large">
      Download CSV
    </StyledButton>
  </ActionBox>
)

export { HeaderAction }
